import React from 'react';
import { DateTime } from 'luxon';

const ProductInorganic = ({ job }) => {

    const removalDate = DateTime.fromISO(job.dateOfFirstAction).toFormat("dd LLL yyyy");

    return (
        <tr>
            <td className="text-left py-3">
                <div>
                    <div className="text-gray-700">
                        Inorganic Collection
                    </div>
                    <div className="text-sm font-light text-gray-500">
                        Removal: {removalDate}
                    </div>
                </div>
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.price}
            </td>
            <td className="px-3 text-gray-700 align-top pt-3">
                ${job.price}
            </td>
        </tr>
    )
}

export default ProductInorganic;